export default "__VITE_ASSET__XHvBzqmc__"